import { addToCart, removeFromCart, setProductQuantity } from 'cart';
import classNames from 'classnames';
import Price from 'components/Price';
import Icon from 'components/UI/Icon';
import React, { useContext, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setSelectedProduct } from '../../../b2b/actions';
import './AddToCartButton.scss';
import { ProductContext } from 'product';
const minusIcon = require('theme/icons/minus.svg');
const plusIcon = require('theme/icons/plus.svg');
function handleSetSelected(event, dispatch, product) {
    event.stopPropagation();
    dispatch(setSelectedProduct(product));
}
function handleAddToCart(event, dispatch, product, productContext) {
    event.stopPropagation();
    dispatch(addToCart(product, productContext));
}
function handleIncreaseAmount(event, dispatch, product, productContext) {
    event.stopPropagation();
    dispatch(addToCart(product, productContext));
}
function handleDecreaseAmount(event, dispatch, product) {
    event.stopPropagation();
    dispatch(removeFromCart(product));
}
function handleChangeAmount(value, dispatch, product) {
    const newQuantity = Math.floor(+value);
    dispatch(setProductQuantity(newQuantity, product));
}
function AddToCartButton({ product, shrinkOnMobile, amountInCart, isBusiness = false, isSelected, soldOut }) {
    const dispatch = useDispatch();
    const productContext = useContext(ProductContext);
    const [amountInput, setAmountInput] = useState(amountInCart.toString());
    useEffect(() => {
        setAmountInput(amountInCart.toString());
    }, [amountInCart]);
    if (isBusiness && isSelected) {
        const classes = classNames({
            'add-to-cart-button-v2': true,
            'add-to-cart-button-v2--selected': true,
            'add-to-cart-button-v2--shrink-on-mobile': shrinkOnMobile,
        });
        return React.createElement("button", { className: classes }, "Du har valgt denne");
    }
    if (soldOut) {
        const soldOutClasses = classNames({
            'sold-out-button-placeholder': true,
            'sold-out-button-placeholder--shrink-on-mobile': shrinkOnMobile,
        });
        return React.createElement("div", { className: soldOutClasses }, "Utsolgt p\u00E5 valgt dato");
    }
    if (amountInCart > 0 && !isBusiness) {
        const adjustCartClasses = classNames({
            'adjust-cart-content': true,
            'adjust-cart-content--shrink-on-mobile': shrinkOnMobile,
        });
        return (React.createElement("div", { className: adjustCartClasses, onClick: (e) => e.stopPropagation() },
            React.createElement("button", { className: "adjust-cart-content__button", onClick: (e) => handleDecreaseAmount(e, dispatch, product) },
                React.createElement(Icon, { svg: minusIcon, className: "adjust-cart-content__button__icon" })),
            React.createElement("div", null,
                React.createElement("input", { type: "tel", className: "adjust-cart-content__input", size: amountInput.length || 1, value: amountInput, onChange: (e) => +e.target.value > -1 && setAmountInput(e.target.value), onBlur: (e) => handleChangeAmount(e.target.value, dispatch, product), onKeyUp: (e) => {
                        if (e.key === 'Enter') {
                            e.currentTarget.blur();
                            handleChangeAmount(e.currentTarget.value, dispatch, product);
                        }
                    } }),
                React.createElement("span", { className: "adjust-cart-content__multiplier" }, "x\u00A0"),
                React.createElement(Price, { amount: product.price })),
            React.createElement("button", { className: "adjust-cart-content__button", onClick: (e) => handleIncreaseAmount(e, dispatch, product, productContext) },
                React.createElement(Icon, { svg: plusIcon, className: "adjust-cart-content__button__icon" }))));
    }
    const addClasses = classNames({
        'add-to-cart-button-v2': true,
        'add-to-cart-button-v2--shrink-on-mobile': shrinkOnMobile,
    });
    const firstWord = isBusiness ? 'Velg' : 'Kjøp';
    const price = isBusiness ? product.b2bPrice : product.price;
    return (React.createElement("button", { className: addClasses, onClick: (e) => isBusiness
            ? handleSetSelected(e, dispatch, product)
            : handleAddToCart(e, dispatch, product, productContext) },
        firstWord,
        " for ",
        React.createElement(Price, { amount: price })));
}
function mapStateToProps(state, props) {
    var _a, _b;
    return {
        product: props.product,
        shrinkOnMobile: props.shrinkOnMobile,
        amountInCart: ((_a = state.cart.products.filter((p) => p.id === props.product.id)[0]) === null || _a === void 0 ? void 0 : _a.quantity) || 0,
        isBusiness: props.isBusiness,
        isSelected: ((_b = state.businessInfo.selectedProduct) === null || _b === void 0 ? void 0 : _b.id) === props.product.id,
        soldOut: props.soldOut
    };
}
export default connect(mapStateToProps)(AddToCartButton);
